import React, { createContext, useContext, useMemo, useState } from 'react';

const SharedContext = createContext<any>(null);

export const StatusProvider = ({ children }:any) => {
  const [sharedValue, setSharedValue] = useState('');
  const contextValue = useMemo(
    () => ({ sharedValue, setSharedValue }),
    [sharedValue]
  );
  return (
    <SharedContext.Provider value={contextValue}>{children}</SharedContext.Provider>
  );
};

export const useSharedContext = () => {
  const context = useContext(SharedContext);
  if (!context) {
    throw new Error('useSharedContext must be used within a SharedProvider');
  }
  return context;
};
